import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa';
import { Container, Card, Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import axios from '../../services/axios';
import Loading from '../../components/Loading';
import Breadcrumbs from '../../components/Breadcrumbs';
import DataTable from '../../components/DataTable';
import ButtonModal from '../../components/ModalConfirmation/ButtonModal';
import { useNotification } from '../../components/Notification/NotificationContext';
import ErrorProcessor from '../../components/ErrorProcessor';
import CardHeaderMore from '../../components/Cards/CardHeaderMore';

export default function PaymentMethods() {
  const routeName = '/paymentmethods';
  const dataName = 'Convênio de pagamento';
  const titleName = 'Convênios de pagamentos';
  const navigate = useNavigate();
  const [apiErrors, setApiErrors] = useState({});
  const notification = useNotification();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const userData = useSelector((state) => state.auth.user);
  const tableColumns = useMemo(
    () => [
      {
        Header: 'Nome',
        accessor: 'name',
      },
      {
        Header: 'Empresa',
        accessor: 'company_name',
      },
      {
        Header: 'Tipo de pagamento',
        accessor: 'payment_type_name',
      },
      {
        Header: 'Provedor',
        accessor: 'payment_provider_name',
      },
    ],
    []
  );

  const getData = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(routeName);
      setData(response.data);
    } catch (err) {
      setApiErrors(err);
      setData([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const confirmDelete = useCallback(async (id) => {
    try {
      setIsLoading(true);
      await axios.delete(`${routeName}/${id}`);
      notification(`${dataName} removido com sucesso`, 'success');
      getData();
    } catch (err) {
      setApiErrors(err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const tableData = useMemo(() => {
    return data.map((provider) => {
      const linksAction = [
        {
          onclick: () => {
            navigate(`${routeName}/${provider.id}/edit`);
          },
          faicon: 'faEdit',
          text: 'Atualizar',
        },
      ];

      if (userData.isadmin === 1) {
        linksAction.push({
          custom: (
            <ButtonModal
              onConfirm={() => confirmDelete(provider.id)}
              message={`Confirma remoção do ${dataName} ${provider.name}?`}
              buttonProps={{ text: 'Remover', faicon: 'faTrash' }}
              textModal={{
                title: `Remover ${dataName}`,
                textConfirm: 'Remover',
              }}
              dropdown
            />
          ),
        });
      }

      return {
        company_name: provider.Company.name,
        payment_type_name: provider.PaymentType.name,
        payment_provider_name: (
          <div className="d-flex justify-content-between">
            <span>{provider.PaymentProvider.name}</span>
            <CardHeaderMore links={linksAction} className="" />
          </div>
        ),
        ...provider,
      };
    });
  }, [data, userData]);

  useEffect(() => {
    getData();
  }, []);

  return (
    <Container fluid className="px-lg-4 px-xl-5">
      <Loading isLoading={isLoading} />
      <Breadcrumbs title="Convênios de pagamentos" />
      <div className="page-header d-flex justify-content-between align-items-center">
        <h1 className="page-heading">{titleName}</h1>
        <div>
          <Link to={`${routeName}/new`}>
            <Button variant="primary" className="text-uppercase">
              <FaPlus /> Cadastrar
            </Button>
          </Link>
        </div>
      </div>
      <section>
        <Card className="card-table mb-5">
          <ErrorProcessor error={apiErrors} />
          <DataTable
            items={tableData}
            columns={tableColumns}
            defaultPageSize={5}
          />
        </Card>
      </section>
    </Container>
  );
}
